import React, { useState, useEffect } from "react" ;

import TeamAppBody from "./Body/TeamAppBody";
import TeamAppSidebar from "./Sidebar/TeamAppSidebar";
import {useRecoilValue} from "recoil";
import {teamIdAtom} from "root/recoil/teamId";

const WieldyApplicationModuleTeam = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    const teamId = useRecoilValue(teamIdAtom);

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    const getTeamId = () =>
    {
        let currentTeamId = 0;

        if(props.match.params.team_id !== undefined){
            currentTeamId = props.match.params.team_id;
        }
        else{
            currentTeamId = teamId;
        }

        return currentTeamId;
    }

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    { getTeamId() !== null && <TeamAppSidebar title={'Team'} team_id={getTeamId()} iconName={'icon-team'} height={height}/>}

                    { getTeamId() !== null && <TeamAppBody team_id={getTeamId()} height={height} width={width}/>}

                    { /* <TeamAppDrawer /> */ }

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleTeam;